export const DEFAULT_DAYS_TO_SKIP_BETWEEN_APPOINTMENTS = 1;

export const MILLISECONDS_SPACING_SINCE_LAST_CALL = 24 * 60 * 60 * 1000;
